import React from 'react'
import _ from 'lodash'

// compact password scoring by tm_lv
// http://stackoverflow.com/questions/948172/password-strength-meter
export function scorePassword(pass) {
   let score = 0

   if (!pass) {
      return score
   }

   // award every unique letter until 5 repetitions
   let letters = {}

   for (let i = 0; i < pass.length; i = i + 1) {
      letters[pass[i]] = (letters[pass[i]] || 0) + 1
      score = score + 5.0 / letters[pass[i]]
   }

   // bonus points for mixing it up
   let variations = {
      digits:   /\d/.test(pass),
      lower:    /[a-z]/.test(pass),
      upper:    /[A-Z]/.test(pass),
      nonWords: /\W/.test(pass)
   }

   let variationCount = 0

   _.each(variations, function(v) {
      variationCount = variationCount + (true === v ? 1 : 0)
   })

   score = score + (variationCount - 1) * 10

   return parseInt(score, 10)
}

export const PasswordStrength = function({score, error, ...props}) {
   console.log('asdasd', {score, error, ...props})
   const strength = parseInt(score / 25, 10),
      scoreClass = 'strength-' + strength,
      quality = ['terrible', 'poor', 'average', 'good', 'excellent']

   if (score) {
      return (
         <div>
            <div className={'password-strength ' + scoreClass}>
               <span className="bar-1" />
               <span className="bar-2" />
               <span className="bar-3" />
               <span className="bar-4" />
            </div>

            <span className="help-block">
               {error && error}
               {!error &&
                  <span className={'password-strength-text ' + scoreClass}>
                     Password strength: {quality[strength]}
                  </span>}
            </span>
         </div>
      )
   }

   return null
}

PasswordStrength.propTypes = {
   score: React.PropTypes.number,
   error: React.PropTypes.string
}



// WEBPACK FOOTER //
// lib/bundle/user/account/PasswordStrength.jsx